import { SxProps, Theme } from '@mui/material';
import { AI_GRADIENT_CSS as AI_GRADIENT, aiGradientTextSx } from 'common/constants/ai';

export const toolbarContainerSx: SxProps<Theme> = {
  display: 'flex',
  gap: 1,
  alignItems: 'center',
  my: 0.5,
};

export const acceptAllButtonGroupSx: SxProps<Theme> = {
  '& .MuiButtonGroup-grouped': {
    border: 'none !important',
  },
  '& .MuiButtonGroup-grouped + .MuiButtonGroup-grouped': {
    borderLeft: '1px solid rgba(255,255,255,0.3) !important',
  },
};

export const acceptAllButtonSx: SxProps<Theme> = {
  background: AI_GRADIENT,
  color: 'white',
}

/** Tight split control: no gap between label button and chevron (MUI buttons default to 8px sibling margin in some themes). */
export const createLabelsSplitGroupSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  gap: 0,
  '& > .MuiButton-root': { margin: 0 },
};

export const dropdownChevronButtonSx: SxProps<Theme> = {
  p: 0,
  pl: 0,
  pr: 0.25,
  minWidth: 0,
  width: 'auto',
  '& .MuiButton-endIcon': { marginLeft: 0 },
};

export const createLabelsButtonSx: SxProps<Theme> = {
  textTransform: 'none',
  whiteSpace: 'nowrap',
  border: 'none',
  py: 0.25,
  px: 1,
  minHeight: 0,
  lineHeight: 1.2,
  fontSize: '0.75rem',
  '&:hover': {
    border: 'none',
    backgroundColor: 'transparent',
  },
};

/** Primary half of split control: flush against chevron button. */
export const createLabelsPrimarySplitButtonSx: SxProps<Theme> = {
  ...createLabelsButtonSx,
  pr: 0,
};

export const pushMappingsButtonSx: SxProps<Theme> = {
  textTransform: 'none',
  whiteSpace: 'nowrap',
  py: 0.25,
  px: 1.5,
  minHeight: 0,
  lineHeight: 1.2,
  fontSize: '0.75rem',
};

export const aiIconSx: SxProps<Theme> = {
  width: 16,
  height: 16,
  marginRight: 0.5,
  marginTop: '4px',
};

export const menuItemAiIconSx: SxProps<Theme> = {
  width: 14,
  height: 14,
  marginRight: 1,
};

export const aiMenuItemTextSx: SxProps<Theme> = {
  ...(aiGradientTextSx as Record<string, unknown>),
  fontWeight: 500,
};

export const createLabelsTextSx: SxProps<Theme> = {
  ...(aiGradientTextSx as Record<string, unknown>),
  fontWeight: 600,
  textTransform: 'none',
  fontSize: '0.75rem',
  py: 0.25,
  px: 1.25,
  minHeight: 0,
  lineHeight: 1.4,
  display: 'flex',
  alignItems: 'center',
  '&:hover': { filter: 'brightness(0.9)', background: AI_GRADIENT },
  '&.Mui-disabled': { background: AI_GRADIENT, opacity: 0.45, color: 'white' },
};

const AI_GRADIENT_DROPDOWN = 'linear-gradient(270deg, #A614FF 10%, #1F55F8 70%)';

export const acceptAllDropdownSx: SxProps<Theme> = {
  background: AI_GRADIENT_DROPDOWN,
  color: 'white',
  py: 0.25,
  px: 0.5,
  minWidth: 0,
  minHeight: 0,
  '&:hover': { filter: 'brightness(0.9)', background: AI_GRADIENT_DROPDOWN },
  '&.Mui-disabled': { background: AI_GRADIENT_DROPDOWN, opacity: 0.45, color: 'white' },
};

export const popperSx: SxProps<Theme> = {
  zIndex: 1,
};

export const acceptAllConfirmButtonSx: SxProps<Theme> = {
  background: AI_GRADIENT,
  color: 'white',
  fontWeight: 600,
  textTransform: 'none',
  '&:hover': { filter: 'brightness(0.9)', background: AI_GRADIENT },
  '&.Mui-disabled': { background: AI_GRADIENT, opacity: 0.6, color: 'white' },
};
